import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { WidgetInput } from '@trackback/widgets';

@Component({
  selector: 'tb-dynamic-widget-page',
  template: `<ng-container [dynamicWidget]="widget()" [context]="{}" />`,
  styles: [
    `
      :host {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DynamicWidgetDirective],
})
export class DynamicWidgetPageComponent {
  widget = input.required<WidgetInput>();
}
